'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _translatr = require('translatr');
var _translatr2 = _interopRequireDefault(_translatr);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Loc = function Loc(_ref) {
  var currentLanguage = _ref.currentLanguage,
    locKey = _ref.locKey,
    number = _ref.number,
    dictionary = _ref.dictionary,
    dispatch = _ref.dispatch,
    rest = (0, _objectWithoutProperties3.default)(_ref, ['currentLanguage', 'locKey', 'number', 'dictionary', 'dispatch']);
  return _react2.default.createElement('span', rest, (0, _translatr2.default)(dictionary, currentLanguage, locKey, number));
};
exports.default = Loc;